export default {
    props: {
        ossKey: {
            type: Object,
            default: function () {
                return {};
            }
        },
        loading: {
            type: Boolean,
            default: false
        },
        width: {
            type: [Number, String],
            default: 360
        },
        // button text
        btnTxt: {
            type: [Number, String],
            default: "确定"
        },
        // 是否是长按钮
        long: {
            type: Boolean,
            default: false
        },
        // 是否需要取消
        cel: {
            type: Boolean,
            default: false
        },
        // 不显示底部
        footerHide: {
            type: Boolean,
            default: true
        },
        className: {
            type: String,
            default: "specailDialog"
        }
    }
}